import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setThemeSettings } from "../core/data/redux/commonSlice";

import { Outlet, useNavigate } from "react-router";
import ThemeSettings from "../core/common/theme-settings/themeSettings";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import { useUser } from "../context/userContext";
import { useIdleTimeout } from "../hooks/useIdleTimeout";
import { isTokenExpired } from "../services/api";

const Feature = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clearUserData } = useUser();
  const themeOpen = useSelector((state: any) => state?.themeSettings);

  // Redireciona ao login se o token já estiver expirado ao carregar
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || isTokenExpired(token)) {
      clearUserData();
      localStorage.removeItem('token');
      localStorage.removeItem('permissions');
      navigate('/login', { replace: true });
    }
  }, []);

  const handleIdle = useCallback(() => {
    clearUserData();
    localStorage.removeItem('token');
    localStorage.removeItem('permissions');
    navigate('/login', { replace: true });
  }, [clearUserData, navigate]);

  useIdleTimeout(handleIdle, 30);
  const headerCollapse = useSelector((state: any) => state.headerCollapse);
  const mobileSidebar = useSelector((state: any) => state.mobileSidebar);
  const miniSidebar = useSelector((state: any) => state.miniSidebar);
  const expandMenu = useSelector((state: any) => state.expandMenu);
 
  return (
    <div className={`
      ${miniSidebar ? "mini-sidebar" : ""}
      ${expandMenu ? "expand-menu" : ""}`}>
     
       <div
        className={`main-wrapper 
        ${headerCollapse ? "header-collapse" : ""} 
        ${mobileSidebar ? "slide-nav" : ""}`}
      >
        <Header />
        <Sidebar/>
        <Outlet />
      </div>
      <div className="sidebar-overlay"></div>
      <div
        className={`sidebar-themeoverlay ${themeOpen ? "open" : ""}`}
        onClick={() => dispatch(setThemeSettings(!themeOpen))}
      ></div>
    </div>
  );
};

export default Feature;
